// keyword filter
var pkwRegex;

jQuery(document).ready(function($){

  if($('#post-archive-grid').length) {

    $('#posts-search-form').submit(function(e) {
      e.preventDefault();
    });

    var $postsGrid = $('#post-archive-grid').isotope({
      layoutMode: 'fitRows',
      filter: function() {
        var chosenOne = true;
        chosenOne = pkwRegex ? $(this).text().match( pkwRegex ) : true;

        if($('#post-filter-select').val() !== 'all') {
          if(!$(this).attr('data-cat-slug-list').includes($('#post-filter-select').val())) {
            chosenOne = false;
          }
        }

        return chosenOne;
      }
    });

    var $pkeywordsearch = $('#post-search-field').on('keyup change copy paste cut blur search', debounce( function() {
      pkwRegex = new RegExp( $pkeywordsearch.val(), 'gi' );
      $postsGrid.isotope();
    }, 200 ) );

    $('#post-filter-select').on('change', function( ){
      updateFilterButtons($(this).val());
      $postsGrid.isotope();
    });

    $('#post-filter-list button').click(function() {
      updateFilterSelect($(this).attr('data-cat-slug'));
    });

    function updateFilterButtons(dataSlug) {
      $('#post-filter-list button').each(function() {
        $(this).removeClass('selected');
      });
      $('#post-filter-list button[data-cat-slug="'+dataSlug+'"]').addClass('selected');
    }

    function updateFilterSelect(dataSlug) {
      $('#post-filter-list button').each(function() {
        $(this).removeClass('selected');
      });
      $('#post-filter-list button[data-cat-slug="'+dataSlug+'"]').addClass('selected');
      $('#post-filter-select').val(dataSlug);
      $('#post-filter-select').change();
    }

    $postsGrid.isotope( 'on', 'layoutComplete', function( event, filteredItems ) {
      isotopeEqualHeights('#post-archive-grid', ' .cell');

      if ( $postsGrid.data('isotope').filteredItems.length == 0) {
        $('.post-archive-grid-container .no-results-found').removeClass('hide');
      } else {
        $('.post-archive-grid-container .no-results-found').addClass('hide');
      }

      // console.log($postsGrid.data('isotope').filteredItems.length);
    });

    function isotopeEqualHeights(container, items) {
  		var row = 1;
  		var top = 0;

  		$(container).find(items).each(function(){
  			$(this).removeClass(function(index, className){
  				return (className.match(/(^|\s)row-\S+/g) || []).join(' ');
  			});
  			var itemTop = parseInt($(this).css('top'), 10);
  			if($(this).is(':visible')){
  				if(itemTop == top){
  					$(this).addClass('row-'+row);
  				} else {
  					top = itemTop;
  					row++;
  					$(this).addClass('row-'+row);
  				}
  			}
  		});
  		for(i = 1; i <= row; i++){
  			listingHeight(container, '.cell.row-'+i+'', null);
  		}
  	}

    function listingHeight(container, item, absContent) {
  		$(container).each(function() {
  			var selectedContainer = $(this);
  			var height = 0;
  			// Reset all the heights so the reading is correct
  			selectedContainer.find(item).css('height', '');
  			// Fugure out which item is the tallest
  			selectedContainer.find(item).each( function() {
  				var item = $(this);
  				if (absContent == null) {
  					var itemHeight = item.innerHeight();
  				} else {
  					var itemHeight = item.innerHeight() + item.find(absContent).innerHeight();
  				}

  				if (itemHeight > height) {
  					height = itemHeight;
  				}
  			});

        // console.log(container, item, height);
  			// Set min height on all of the items
  			selectedContainer.find(item).css('height', height);
  		});

  	}

    $postsGrid.isotope('layout');





  }




});
